import { render, staticRenderFns } from "./moreCustom.vue?vue&type=template&id=6a70a278&scoped=true&"
import script from "./moreCustom.vue?vue&type=script&lang=js&"
export * from "./moreCustom.vue?vue&type=script&lang=js&"
import style0 from "./moreCustom.vue?vue&type=style&index=0&id=6a70a278&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a70a278",
  null
  
)

component.options.__file = "moreCustom.vue"
export default component.exports